// Config panel for the "delay" action block
import React from 'react';
import {
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography
} from '@mui/material';

const DelayConfig = ({ config, onChange, onSummaryChange }) => {
  const handleChange = (field, value) => {
    const updated = { ...config, [field]: value };
    onChange(updated);
    onSummaryChange(`Wait ${updated.duration || '?'} ${updated.unit || 'seconds'}`);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Pauses execution for a specified duration before continuing to the next block.
        Maximum: 10 minutes.
      </Typography>

      <TextField
        size="small"
        label="Duration"
        value={config.duration ?? ''}
        onChange={(e) => handleChange('duration', e.target.value)}
        required
        placeholder="5 or {{delaySeconds}}"
        helperText="Number or {{variable}}. Max 10 minutes."
      />

      <FormControl fullWidth size="small">
        <InputLabel>Unit</InputLabel>
        <Select
          value={config.unit || 'seconds'}
          onChange={(e) => handleChange('unit', e.target.value)}
          label="Unit"
        >
          <MenuItem value="seconds">Seconds</MenuItem>
          <MenuItem value="minutes">Minutes</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default DelayConfig;
